export default "__VITE_ASSET__Df5$Opri__"